import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { company } from '../data/content';
import { CheckIcon, ArrowRightIcon, StarIcon, HomeIcon, BoltIcon, PriceTagIcon } from './icons';
const ease = [0.23, 1, 0.32, 1] as const;
const trustMarks = ['Licensed & Insured', 'Family-Owned', 'Guaranteed'];
const badges = [{
  icon: StarIcon,
  value: '5.0',
  label: 'Rating'
}, {
  icon: HomeIcon,
  value: '500+',
  label: 'Homes'
}, {
  icon: BoltIcon,
  value: '4 Wks',
  label: 'Turnaround'
}, {
  icon: PriceTagIcon,
  value: 'Fixed',
  label: 'Pricing'
}];
function RippleTexture() {
  return <svg aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full opacity-[0.18]" data-id="element-665" data-mp="1doeecpsbyvqm">
      <defs data-id="element-666" data-mp="1il4t99seflag">
        <pattern id="aj-ripple" width="140" height="44" patternUnits="userSpaceOnUse" data-id="element-667" data-mp="1ikuzrc85aw00">
          <path d="M0 22 Q 17.5 8 35 22 T 70 22 T 105 22 T 140 22" fill="none" stroke="#0099FF" strokeWidth="1.5" data-id="element-668" data-mp="26apha73et8ql" />
          <path d="M0 44 Q 17.5 30 35 44 T 70 44 T 105 44 T 140 44" fill="none" stroke="#0099FF" strokeWidth="1" opacity="0.6" data-id="element-669" data-mp="3arvc38sr7yj1" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#aj-ripple)" data-id="element-670" data-mp="3jkf25kuzcus9" />
    </svg>;
}
export function TransformationBanner() {
  const reduceMotion = useReducedMotion();
  return <section id="transformation" aria-labelledby="banner-heading" className="relative w-full overflow-hidden bg-ink py-16 lg:py-20" data-id="element-671" data-mp="3tg8p7y6bs6oa">
      <RippleTexture data-id="element-672" data-mp="6clotmfvl6iu" />

      <div className="relative mx-auto max-w-content px-5 lg:px-8" data-id="element-673" data-mp="6cvibk04pvta">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,6fr)_minmax(0,4fr)] lg:items-center lg:gap-14" data-id="element-674" data-mp="2b0ikjxujqhm">
          {/* Before / after split */}
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          ease
        }} className="relative" data-id="element-675" data-mp="285092s5w6n2f">
            <figure className="relative overflow-hidden rounded-xl" data-id="element-676" data-mp="c0u0qrf34q2r">
              <div className="relative" data-id="element-677" data-mp="c12esmmy21fj">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/1a8fd1c1-0f0f-461f-ac73-9009f5eb0fe6.jpg" alt="Neglected backyard pool with cracked stained plaster, missing tile, and murky green water" className="h-[190px] w-full object-cover sm:h-[230px] lg:h-[215px]" data-id="element-678" data-mp="gzds57cg6u2i" />
                <span aria-hidden="true" className="absolute inset-0 bg-ink/20" data-id="element-679" data-mp="uxljmzqpt36a" />
                <figcaption className="absolute left-4 top-4 flex items-center gap-2 rounded-sm border border-white/35 bg-ink/80 px-3 py-1.5" data-id="element-680" data-mp="zqwsf6f37u0u">
                  <span className="font-banner text-[11px] font-extrabold uppercase tracking-[0.2em] text-white/70" data-id="element-681" data-mp="19oufvrp4hmse">
                    Before
                  </span>
                  <span className="h-3 w-px bg-white/30" aria-hidden="true" data-id="element-682" data-mp="1do38uucc9gmw" />
                  <span className="font-banner text-[13px] font-black uppercase tracking-wide text-white" data-id="element-683" data-mp="2y9rv5xebnjx3">
                    Eyesore
                  </span>
                </figcaption>
              </div>

              <div className="relative flex items-center bg-ember py-[3px]" data-id="element-684" data-mp="2p8210jt226vm">
                <span className="absolute left-1/2 z-10 flex h-9 w-9 -translate-x-1/2 items-center justify-center rounded-full bg-gold shadow-lg shadow-ink/60" data-id="element-685" data-mp="2k9h00i5zbj64">
                  <ArrowRightIcon className="h-4 w-4 rotate-90 text-ink" data-id="element-686" data-mp="3cxcwpmvjtb2w" />
                </span>
              </div>

              <div className="relative" data-id="element-687" data-mp="385uyh6kwtolm">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/42da03a6-0f96-4a8a-9eec-ae01854d4b8d.jpg" alt="The same pool fully restored with crystal clear turquoise water, new plaster, tile, and coping" className="h-[230px] w-full object-cover sm:h-[280px] lg:h-[265px]" data-id="element-688" data-mp="384jt52btg8se" />
                <figcaption className="absolute left-4 top-4 flex items-center gap-2 rounded-sm bg-gold px-3 py-1.5" data-id="element-689" data-mp="3gdpii32y17at">
                  <span className="font-banner text-[11px] font-extrabold uppercase tracking-[0.2em] text-ink/70" data-id="element-690" data-mp="3kgc8rzjyuk5w">
                    After
                  </span>
                  <span className="h-3 w-px bg-ink/30" aria-hidden="true" data-id="element-691" data-mp="3becomydnmzyq" />
                  <span className="font-banner text-[13px] font-black uppercase tracking-wide text-ink" data-id="element-692" data-mp="2z2ovwx8m6u4">
                    Resort-Ready
                  </span>
                </figcaption>
              </div>
            </figure>

            <span aria-hidden="true" className="pointer-events-none absolute -inset-x-2 bottom-0 h-1/2 rounded-xl shadow-[0_28px_70px_-18px_rgba(0,153,255,0.75)]" data-id="element-693" data-mp="3pffapb4nga9n" />
          </motion.div>

          {/* Copy stack */}
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease
        }} data-id="element-694" data-mp="lw3xdrq02p2t">
            <p className="font-banner text-[11px] font-extrabold uppercase tracking-[0.3em] text-azure" data-id="element-695" data-mp="26gr7gmz8dztp">
              The A&amp;J Effect
            </p>
            <h2 id="banner-heading" className="mt-4 font-banner text-4xl font-black uppercase leading-[0.92] tracking-tight text-white sm:text-5xl" data-id="element-696" data-mp="2k9gqqjndkqn4">
              20 Years of
              <span className="block text-gold" data-id="element-697" data-mp="1nh3ig31lnrqn">Transformation</span>
            </h2>
            <p className="mt-5 font-banner text-lg font-semibold text-white/85 sm:text-xl" data-id="element-698" data-mp="1njg7t19ot4dq">
              500+ Pools. 9/10 Recommend. 0 Excuses.
            </p>

            <span aria-hidden="true" className="mt-7 block h-1 w-28 bg-ember" data-id="element-699" data-mp="1wh0ckk6rdit3" />

            <ul className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2.5" data-id="element-700" data-mp="3cv8l3aup1rlq">
              {trustMarks.map(mark => <li key={mark} className="flex items-center gap-2 text-sm font-semibold text-white" data-id="element-701" data-mp="37wf61dzrdsjg">
                  <CheckIcon className="h-4 w-4 shrink-0 text-gold" data-id="element-702" data-mp="25j0t0pnwbk6h" />
                  {mark}
                </li>)}
            </ul>

            <a href="#contact" className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-md bg-gold px-7 py-4 font-banner text-[15px] font-black uppercase tracking-wide text-ink transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#FFE34D] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:w-auto" data-id="element-703" data-mp="2ekguu90nadz3">
              Claim your free estimate
              <ArrowRightIcon className="h-5 w-5" data-id="element-704" data-mp="20k62f1josrbt" />
            </a>
            <p className="mt-3 text-sm text-white/65" data-id="element-705" data-mp="20misk1zlm7zy">
              Call or text {company.phoneDisplay} — no pressure, no tricks.
            </p>

            <ul className="mt-9 grid grid-cols-4 gap-3 sm:gap-4" data-id="element-706" data-mp="183d7beutjulo">
              {badges.map((badge, index) => <motion.li key={badge.label} animate={reduceMotion ? undefined : {
              y: [0, -6, 0]
            }} transition={{
              duration: 4.5,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: index * 0.35
            }} className="flex aspect-square flex-col items-center justify-center rounded-full border border-azure/45 bg-white/[0.06] px-1 text-center backdrop-blur-sm" data-id="element-707" data-mp="10jkrp260yvyf" data-mpi={index}>
                  <badge.icon className="h-4 w-4 text-gold sm:h-5 sm:w-5" data-id="element-708" data-mp="csyih7kab5mu" />
                  <span className="mt-1 font-banner text-[13px] font-black leading-none text-white sm:text-base" data-id="element-709" data-mp="7wq9yd0leaon">
                    {badge.value}
                  </span>
                  <span className="mt-1 text-[10px] font-semibold uppercase tracking-wide text-white/65" data-id="element-710" data-mp="3v0xq6tx1mui1">
                    {badge.label}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}